// The value in grades is an array of strings.
// In order to use reduce() properly, it has to be converted to numbers.
// One of the fastest methods is to multiply numeric string by 1.
import React from "react";
/**
 *
 * @param {Array} props.grades an array of students' grades.
 * @returns The average percentage value from an array of numbers.
 */
const AverageGrades = ({ grades }) => {
  const result =
    grades.map(grade => grade * 1).reduce((acc, cur) => acc + cur, 0) /
    grades.length;
  return <div>Average: {result}%</div>;
};

export default AverageGrades;
